// extracted by mini-css-extract-plugin
export var form = "credit-card-data-module--form--2014e";
export var iconBox = "credit-card-data-module--icon-box--f1b57";
export var info = "credit-card-data-module--info--ab69e";
export var infoBox = "credit-card-data-module--info-box--b934e";
export var infoCard = "credit-card-data-module--info-card--23444";
export var infoCardContent = "credit-card-data-module--info-card-content--b9f46";
export var infoCardText = "credit-card-data-module--info-card-text--27889";
export var infoCardTitle = "credit-card-data-module--info-card-title--48886";
export var infoHeader = "credit-card-data-module--info-header--a36bc";
export var loaderBox = "credit-card-data-module--loader-box--4f5f1";
export var logo = "credit-card-data-module--logo--33542";
export var payuImg = "credit-card-data-module--payu-img--54019";
export var statusItem = "credit-card-data-module--status-item--0d75f";
export var statusList = "credit-card-data-module--status-list--63efb";
export var title = "credit-card-data-module--title--c1a50";
export var wrapper = "credit-card-data-module--wrapper--bb3a5";